import en from './en'
import zh from './zh'
import ja from './ja'
export default {
  en,
  zh,
  ja
}
